import { Input } from 'rsuite';

const SCInput = (props) => {
    return (
        <Input {...props}>{props.children}</Input>
    );
}

export default SCInput;